import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';


import * as PD from '../classes/pdStyle';

import {cloneObject, getParam} from '../utils/utils';
import {formatDate, formatText, truncate} from '../utils/utils';

import Rendition from '../components/Rendition';


import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";
import ViewInterface from "../components/ViewInterface";
import ViewMetadata from "../components/ViewMetadata";

import ListParameters from "../components/ListParameters";
import ListMethods from "../components/ListMethods";


//import FormElement from "../components/FormElement";

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
import ViewInterfaceVersion from "../components/ViewInterfaceVersion";

import FormIdDataSpec from "../components/FormIdDataSpec";



import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import Buffering from "../components/Buffering";

import {getInterface, addInterface, editInterface} from '../utils/utilsInterface';

import JSZip from "jszip";




class Interface extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
            loadData:false
        };


        this.data = {};


        this.addDataSpec = this.addDataSpec.bind(this);
        this.removeDataSpec = this.removeDataSpec.bind(this);
        this.updateDataSpec = this.updateDataSpec.bind(this);


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.loadedParameters = this.loadedParameters.bind(this);
        this.loadedMethods = this.loadedMethods.bind(this);


        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);





        this.dsd = new dsd();

        this.FallBackNavigation = `/interfaces`;


    }

    componentDidMount(){

       this.dsd.StateObject = this;
       this.setup();

    }


    componentDidUpdate(prevProps, prevState){

        // Handle route/props changes
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadInterface(id){

        if (id === undefined || id === null){
            return;
        }

        this.setState({ renderState: 'loading' });

        // Main interface load
        const onLoad = function(Interface) {
            let StateChange = {
                Interface: Interface,
                isLoaded: true,
                renderState: 'loaded'
            };

            StateChange.FormData = Interface;
            StateChange.OfferEdit = false;
            
            if (this.dsd.loggedon){
                if (this.dsd.user.id === Interface.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            this.setState(StateChange, () => {
                this.setLayoutContent();

                // Set up breadcrumb navigation
                for (var i in window.Breadcrumb){
                    if (window.Breadcrumb[i][0] === 'interface'){
                        window.Breadcrumb = window.Breadcrumb.slice(0,i);
                        break;
                    }
                }
                this.Breadcrumb = JSON.parse(JSON.stringify(window.Breadcrumb));
                window.Breadcrumb.push(['interface',`/interface/${id}`]);

                this.FallBackNavigation = `../interfaces`;
                this.onUpdateNavigation = this.FallBackNavigation;

                // Fetch OAD if URI exists
                if (this.state.Interface.uri){
                    const onDone = function(oad){
                        this.setState({oad:oad});
                        return;
                    }.bind(this);
        
                    this.dsd.uriDereference(this.state.Interface.uri, onDone);
                }
            });

        }.bind(this);

        const onFail = function(e) {
            if (e.response){
                if (e.response.status === 403){
                    this.setState({
                        renderState: 'denied',
                        errorMessage: 'Access Denied'
                    });
                } else {
                    this.setState({
                        renderState: 'failed',
                        errorMessage: e.message || 'Failed to load interface'
                    });
                }
            } else {
                this.setState({
                    renderState: 'failed',
                    errorMessage: e.message || 'Failed to load interface'
                });
            }
        }.bind(this);

        getInterface(this.dsd, id, onLoad, onFail);
        
        return;
        
    };

    setup(){


        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isError: false,
            isFailed: false,
            renderState: 'loading',
            errorMessage: '',

            OfferEdit: false,

            FormData: {},
            Controls: {
                vizStructures: false
            },

            countParameters : null,
            countMethods : null,


            Interface: null,

            idVersion: null,

            action: null,

            updateToggle: 0,

            countVersions: null,

            oad: {},

        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idInterface = getParam('id', this.props);

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        // For new mode, set as loaded immediately
        if (StateChange.mode === 'new'){
            StateChange.isLoaded = true;
            StateChange.renderState = 'loaded';
        }

        StateChange.idVersion = getParam('idVersion', this.props);

        this.setState(StateChange, () => {
            if (this.state.idInterface && this.state.mode !== 'new'){
                this.loadInterface(this.state.idInterface);
            }
        });
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        switch (FormFieldName){
            case 'vizStructures':
                Controls[FormFieldName] = FormFieldValue;        
                this.setState({"Controls": Controls});
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    


    handleSubmit(event) {

        const onError = function(e){
            let StateChange = {};
            StateChange.isError = true;
            StateChange.errorMessage = e.message;

            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                    if (e.response.data.fields){
                        for (const field in e.response.data.fields){
                            StateChange.invalidFields = e.response.data.fields
                        }
    
                    }
                }
            }
    
            this.setState(StateChange);
            return;
        }.bind(this);

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':
                switch (this.state.mode){
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                    case 'edit':
                        this.props.navigation(`/interface/${this.state.idInterface}`);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    isError: false,
                    invalidFields: false
                })
        
                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(id){
                            this.props.navigation(`/interface/${id}`);
                        }.bind(this);

                        addInterface(this.dsd, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/interface/${this.state.idInterface}`);
                        }.bind(this);

                        editInterface(this.dsd, this.state.idInterface, this.state.FormData, onUpdate, onError);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
            case 'btnAddParameter':
                this.props.navigation(`/interface/${this.state.idInterface}/parameter?mode=new`);
                break;
            case 'btnAddMethod':
                this.props.navigation(`/interface/${this.state.idInterface}/method?mode=new`);
                break;
        }

        this.setState(StateChange);

        event.preventDefault();
    };

    handleAddVersion(event) {

        this.setState({newVersion:true});

    }


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'method':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/method/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'parameter':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/parameter/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'serialization':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/serialization/${partsVizNodeId[1]}`);
                    }
                    break;
            }
        }

        event.preventDefault();

    };



    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.Interface){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idInterface} type='interface' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idInterface}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
       this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }

    loadedParameters(count){

        let StateChange = {};

        StateChange.countParameters = 0;
        if (count){
            StateChange.countParameters = count;
        }

        this.setState(StateChange);

    }

    loadedMethods(count){

        let StateChange = {};

        StateChange.countMethods = 0;
        if (count){
            StateChange.countMethods = count;
        }

        this.setState(StateChange);

    }


    setLayoutContent(){

        if (this.context.hasLayout){
            if (this.state.Interface){
                this.context.Layout.setLeftAsInterface(this.state.Interface._id);
            }
        }

        return;

    }

    showError(){

        return(
            <>
                {this.state.errorMessage &&
                    <p>{this.state.errorMessage}</p>
                }

                {this.state.invalidFields &&
                    Object.keys(this.state.invalidFields).map(
                    (field, pos) => 
                        {
                            let error = this.state.invalidFields[field].error;
                            return <p key={pos}>{field}:{error}</p>
                        }
                    )
                }
            </>
        )

    }


    render() {

        // Handle loading/error states
        if (this.state.mode === 'view'){
            switch(this.state.renderState){
                case 'loading':
                    return <Buffering />;
                case 'failed':
                    return (
                        <div>
                            <PD.ErrorBox>Error: {this.state.errorMessage}</PD.ErrorBox>
                        </div>
                    );
                case 'denied':
                    return (
                        <div>
                            <PD.ErrorBox>Access Denied</PD.ErrorBox>
                        </div>
                    );
                default:
                    break;
            }
        }

        if (this.state.isUpdated){
            switch (this.state.mode){
                case 'remove':
                    this.props.navigation(this.FallBackNavigation);
                    return null;
                default:
                    break;
            };
        };

        if (this.state.isLoaded || this.state.mode === 'new') {

            if (this.state.idVersion){
                return(
                    <ViewInterfaceVersion idInterface={this.state.idInterface} idVersion={this.state.idVersion}/>
                )
            }

            switch (this.state.mode){
                case 'new':
                case 'edit':

                    return (
                    <div>

                        <PD.Heading>{this.state.mode} Interface</PD.Heading>
    
                        {this.state.isError &&
                            <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                        }
    
                        <form> 
                            <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                            <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>
                            <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                            <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                {
                                    this.dsd.config.ComponentStatuses.map(
                                        (status, posStatus) => 
                                            {
                                                return(
                                                    <option key={posStatus} value={status}>{status}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>

                            {this.FormDataSpecs()}

                            <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                            <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                        </form>
    
                    </div>    
                    );
                case 'remove':
                    return (
                        <div>
                            <PD.Heading>{this.state.mode} Interface</PD.Heading>

                            {this.state.isFailed &&
                                <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                            }

                            <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                            <ViewInterface json={this.state.Interface}/>
                        </div>
                    )
                case 'view':
                default:

                    if (!this.state.Interface){
                        return <div/>
                    }
                    
                    return (
                        <div>
                            <div>
                                <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                <PD.Heading>Interface:{this.state.Interface.name}</PD.Heading>
                            </div>

                            {this.state.OfferEdit &&
                                <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                </span>
                            }

                            <ViewInterface Interface={this.state.Interface}/>

                            <br/>

                            <PD.Tabs>

                                <div label={<span>Parameters({this.state.countParameters === null ? <Buffering/> : this.state.countParameters})</span>}  data-forcerender="true">
                                    <div style={{display:"flex"}}>
                                        {this.state.OfferEdit && 
                                            <PD.Button name='btnAddParameter' value='add a new Parameter' onClick={this.handleButton}/>
                                        }
                                    </div>

                                    <ListParameters filters={{idInterface:this.state.idInterface, ...this.state.ParameterFilters}} onLoad={this.loadedParameters} />

                                </div>


                                <div label={<span>Methods({this.state.countMethods === null ? <Buffering/> : this.state.countMethods})</span>}  data-forcerender="true">
                                    <div style={{display:"flex"}}>
                                        {this.state.OfferEdit && 
                                            <PD.Button name='btnAddMethod' value='add a new Method' onClick={this.handleButton}/>
                                        }
                                    </div>

                                    <ListMethods filters={{idInterface:this.state.idInterface, ...this.state.MethodFilters}} onLoad={this.loadedMethods} />

                                </div>

                                <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                    {this.versions()}
                                </div>


                                <div label='Developer'>
                                    <Rendition
                                        endpoint="/interfaces"
                                        id={this.state.idInterface}
                                    />
                                </div>


                                <div label='Metadata'>
                                    <ViewMetadata Data={this.state.Interface} />
                                </div>


                            </PD.Tabs>


                        </div>
                    )
            };
        };

        return <div />;
    };


    FormDataSpecs(){

        let seqNext = 1;
        if (this.state.FormData.DataSpecs){
            seqNext = this.state.FormData.DataSpecs.length + 1;
        }
        return (
            <fieldset>
                <legend>Data Specs</legend>
                {this.state.FormData.DataSpecs &&
                    this.state.FormData.DataSpecs.map(
                        (DataSpec, posDataSpec) => 
                        {
                            let seq = posDataSpec+1;
                            return(
                                this.FormDataSpec('edit', seq, DataSpec)
                            )
                        }
                    )
                }
                {this.FormDataSpec('new', seqNext)}
            </fieldset>
        );

    }

    FormDataSpec(mode, seq, DataSpec = {}){
        return(
            <div>
                <FormIdDataSpec 
                    key={seq.toString()} 
                    mode={mode} 
                    DataSpec={DataSpec} 
                    seq={seq}
                    onAdd={this.addDataSpec}
                    onRemove={this.removeDataSpec}
                    onUpdate={this.updateDataSpec}
                    />
            </div>
        )
    }
    

    addDataSpec(){
       let FormData = {...this.state.FormData};
       FormData.DataSpecs = [...(FormData.DataSpecs || []), {}];
  
       this.setState({"FormData": FormData});

    }

    removeDataSpec(seq){

       let FormData = {...this.state.FormData};
       FormData.DataSpecs = [...(FormData.DataSpecs || [])];
       FormData.DataSpecs.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }


    updateDataSpec(seq, DataSpec){

       let FormData = {...this.state.FormData};
       FormData.DataSpecs = [...(FormData.DataSpecs || [])];
       FormData.DataSpecs[seq-1] = DataSpec;

       this.setState({"FormData": FormData});

    }

};


// Wrap and export
export default function Interface_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Interface {...props} navigation={navigation} location={location} params={params} />;
  }
